import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import Layout from '@/layout/index.vue';
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    return true;
  }
}
function compare() {
  return (a, b) => {
    const sortA = a.sort;
    const sortB = b.sort;
    return sortA - sortB;
  };
}
// 菜单排序
function sortRoutes(routes) {
  const sorted = routes.sort(compare());
  sorted.forEach(item => {
    !item.hidden && item.children.length > 0 && sortRoutes(item.children);
  });
  return sorted;
}
/**
 * 后台查询的菜单数据拼装成路由格式的数据
 * @param routes
 */
export function generaMenu(routes, data) {
  const newMenu = [];
  data.forEach(item => {
    const menu = {
      path: item.functionUri === '#' ? item.code + '_key' : item.functionCode,
      component: item.children === '#' ? Layout : () => import(`@/${item.functionTreePath}/index`),
      hidden: item.hiddenFlag,
      children: [],
      name: item.functionCode,
      meta: {
        title: item.functionName,
        id: item.iconCode,
        only: item.onlyFlag ? item.functionCode : null,
        icon: item.iconCode
      },
      pageUrl: item.functionUri,
      sort: item.sort
    };
    if (item.children) {
      generaMenu(menu.children, item.children);
    }
    newMenu.push(menu);
    routes.push(menu);
  });
  return newMenu;
}
export function filterAsyncRoutes(routes, roles) {
  const res = [];
  routes.forEach(route => {
    const tmp = {
      ...route
    };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });
  return res;
}
export default {
  namespaced: true,
  state: () => ({
    routes: [],
    addRoutes: []
  }),
  mutations: {
    SET_ROUTES(state, routes) {
      state.addRoutes = routes;
      const sortedRoutes = sortRoutes(routes);
      state.routes = sortedRoutes;
    }
  },
  actions: {
    generateRoutes({
      commit
    }) {
      return new Promise(resolve => {
        const loadMenuData = [];
        // 先查询后台并返回左侧菜单数据并把数据添加到路由
        // getAuthMenu().then((response: any) => {
        //   const data = response
        //   Object.assign(loadMenuData, data)
        //   // generaMenu(asyncRoutes, loadMenuData)
        //   const accessedRoutes = generaMenu(asyncRoutes, loadMenuData)
        //   commit('SET_ROUTES', accessedRoutes)
        //   resolve(accessedRoutes)
        // }).catch((error: any) => {
        //   console.error(error)
        // })
      });
    }
  }
};